import { MESSAGE_SETTING_GENERAL_TYPE } from "../constants";

const messageSettingGeneralReducer = (state = {}, action) => {
   switch (action.type) {
      case MESSAGE_SETTING_GENERAL_TYPE.FETCH:
         return {
            ...state,
            ...action.payload
         };
      case MESSAGE_SETTING_GENERAL_TYPE.ON_CHANGE_TEXT:
         return {
            ...state,
            text: action.payload
         };
      case MESSAGE_SETTING_GENERAL_TYPE.ON_CHANGE_ACTIVE:
         return {
            ...state,
            is_actived: action.payload
         };
      default:
         return state;
   }
};

export default messageSettingGeneralReducer;